import script from "./NewTeamGuide.vue?vue&type=script&setup=true&lang=js"
export * from "./NewTeamGuide.vue?vue&type=script&setup=true&lang=js"

import "./NewTeamGuide.vue?vue&type=style&index=0&id=6d2593e0&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d2593e0"]])

export default __exports__